import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import NtMaterialIcon from "./NtMaterialIcon";
import { useTheme } from "../context/ThemeContext";

/**
 * Inline tag for an extension number — phone glyph + monospace number on a
 * subtle chip. Used everywhere we render an extension/ring-group/IVR
 * extension/voicemail-id so the number reads consistently as a "phone ID".
 *
 * <NtExtensionTag extension="1234" />
 */
function NtExtensionTag({ extension, style, size = "md" }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme, size), [theme, size]);
  if (extension === null || extension === undefined || extension === "") return null;
  return (
    <View style={[styles.tag, style]}>
      <NtMaterialIcon
        name="phone"
        color={theme.brand2}
        size={size === "sm" ? 10 : 12}
      />
      <NtText style={styles.text}>{String(extension)}</NtText>
    </View>
  );
}

const makeStyles = (t, size) =>
  StyleSheet.create({
    tag: {
      flexDirection: "row",
      alignItems: "center",
      gap: 6,
      alignSelf: "flex-start",
      paddingVertical: size === "sm" ? 1 : 2,
      paddingHorizontal: size === "sm" ? 6 : 8,
      borderRadius: 4,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
    },
    text: {
      color: t.text,
      fontSize: size === "sm" ? 11 : 12,
      fontWeight: "600",
      fontFamily: "Menlo",
      letterSpacing: 0.4,
    },
  });

export default NtExtensionTag;
